var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-alert',{attrs:{"border":"top","color":"blue-grey","dark":""}},[_vm._v("Codloot Yönetim Paneline Hoşgeldiniz.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }